<template>
  <el-card class="create-smart-link" v-loading="loading">
    <div class="wrapper">
      <!-- Basic Info -->
      <section class="panel mt-6" id="basic-info">
        <div class="divider"><h3>Basic Info</h3></div>
        <el-form ref="createSmartlink" :model="sml_link" :rules="rules" class="flex-center">
          <div class="form-group form-light mt-8">
            <label class="label">
              Campaign name
              <i class="required-mark">*</i>
            </label>
            <div class="form-control">
              <el-form-item prop="name">
                <el-input v-model="sml_link.name"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-group form-light mt-4" style="position: relative">
            <label class="label">
              Offer type
              <i class="required-mark">*</i>
            </label>
            <div class="form-control radio-group">
              <el-form-item>
                <el-select v-model="sml_link.ad_type" @change="changeAdType()">
                  <el-option
                    :label="item.label"
                    :key="item.id"
                    :value="item.id"
                    v-for="item in ad_type"
                    :class="item.id === 4 && customer_type != 1 ? 'cpl_bonus' : ''"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div
            class="form-group form-light card-group mt-4"
            v-if="sml_link.sml_type === 1 && sml_link.ad_type !== 1"
          >
            <label class="label">
              Stream type
              <i class="required-mark">*</i>
            </label>

            <el-radio-group
              v-model="sml_link.restriction_type"
              @change="getOfferList_()"
              class="ml-4"
            >
              <el-card
                v-for="(item, index) in offer_setting.restriction_type"
                :key="item.id"
                :class="{
                  'default-card': sml_link.restriction_type !== item.id,
                  'selected-card': sml_link.restriction_type === item.id,
                  'mr-5': index !== offer_setting.restriction_type.length - 1,
                }"
                class="ad-format-box pointer"
                @click.native="changeRestrictionType(item)"
              >
                <el-radio :label="item.id">{{ item.name }}</el-radio>
                <div class="mt-3">
                  <commonSvg
                    :iconClass="sml_link.restriction_type === item.id ? item.name + 1 : item.name"
                  ></commonSvg>
                </div>
              </el-card>
            </el-radio-group>
          </div>
          <div class="form-group form-light mt-4" v-if="sml_link.ad_type == 4">
            <label class="label">
              <el-tooltip
                enterable
                content="Prelander is a single page that is presented to the visitor before he is directed to the main product website."
                placement="bottom"
              >
                <i class="icon-y-question"></i>
              </el-tooltip>
              Prelander
            </label>
            <div class="form-control radio-group">
              <el-radio-group v-model="sml_link.prelander" @change="changePrelander()">
                <el-radio :label="0">
                  ALL
                </el-radio>
                <el-radio :label="1">
                  Without Prelander
                  <el-tooltip
                    enterable
                    content="You will filter out offers without prelander."
                    placement="bottom"
                  >
                    <i class="icon-y-question"></i>
                  </el-tooltip>
                </el-radio>
                <el-radio :label="2">
                  With Prelander
                  <el-tooltip
                    enterable
                    content="You will filter out offers with prelander."
                    placement="bottom"
                  >
                    <i class="icon-y-question"></i>
                  </el-tooltip>
                </el-radio>
              </el-radio-group>
            </div>
          </div>

          <el-button class="mt-10 xxlong-button grey" v-if="!ifAdvanced" @click="ifAdvanced = true">
            Advanced Setting
            <i class="icon-y-down3"></i>
          </el-button>
        </el-form>
      </section>

      <transition name="fade">
        <div v-show="ifAdvanced">
          <!-- Target -->
          <section class="panel mt-6" id="target">
            <div class="divider"><h3>Targeting (Optional)</h3></div>
            <p>Select below options for your traffic.</p>
            <div class="flex-center">
              <div class="form-group form-light target-group">
                <label class="label mr-8">
                  Country
                </label>
                <el-row class="form-control" :gutter="10">
                  <el-col :md="5" :sm="8" :xs="4">
                    <el-select
                      v-model="x_countrys"
                      :class="x_countrys ? 'deny' : 'allow'"
                      @change="getOfferList_()"
                    >
                      <el-option
                        v-for="item in x_selection"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :md="19" :sm="16" :xs="8">
                    <el-select
                      multiple
                      collapse-tags
                      filterable
                      v-model="country_list"
                      placeholder="Select targeting countires"
                      @change="getOfferList_()"
                    >
                      <el-option
                        v-for="item in countrys"
                        :key="item.code"
                        :label="item.code_name"
                        :value="item.code"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
                <el-button class="ml-2" @click="country_list = []">Clear</el-button>
              </div>
              <div class="tag-wrapper" v-show="country_list.length">
                <el-row class="tag-group">
                  <el-col :md="24">
                    <el-tag
                      class="mb-1 mr-1 target-tag"
                      v-for="tag in countrys"
                      v-show="country_list.includes(tag.code)"
                      :key="tag.code"
                      closable
                      @close="deleteTag(tag.code, 'country_list')"
                      :type="x_countrys ? 'danger' : ''"
                    >
                      {{ tag.code_name }}
                    </el-tag>
                  </el-col>
                </el-row>
              </div>
              <div class="form-group form-light target-group">
                <label class="label mr-8">
                  Category
                </label>
                <el-row class="form-control" :gutter="10">
                  <el-col :md="5" :sm="8" :xs="4">
                    <el-select
                      v-model="x_category"
                      @change="getOfferList_()"
                      :class="x_category ? 'deny' : 'allow'"
                    >
                      <el-option
                        v-for="item in x_selection"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :md="19" :sm="16" :xs="8">
                    <el-select
                      multiple
                      filterable
                      collapse-tags
                      v-model="category_list"
                      placeholder="Select targeting categories"
                      @change="getOfferList_()"
                    >
                      <el-option
                        v-for="item in offer_setting.category"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
                <el-button class="ml-2" @click="category_list = []">Clear</el-button>
              </div>
              <div class="tag-wrapper mb-4" v-show="category_list.length">
                <el-row class="tag-group">
                  <el-col :md="24">
                    <el-tag
                      class="mb-1 mr-1"
                      v-for="tag in offer_setting.category"
                      v-show="category_list.includes(tag.id)"
                      :key="tag.id"
                      @close="deleteTag(tag.id, 'category_list')"
                      closable
                      :type="x_category ? 'danger' : ''"
                    >
                      {{ tag.name }}
                    </el-tag>
                  </el-col>
                </el-row>
              </div>
              <div class="form-group form-light target-group">
                <label class="label mr-8">
                  Conversion Flow
                </label>
                <el-row class="form-control" :gutter="10">
                  <el-col :md="5" :sm="8" :xs="4">
                    <el-select
                      v-model="x_conversion"
                      @change="getOfferList_()"
                      :class="x_conversion ? 'deny' : 'allow'"
                    >
                      <el-option
                        v-for="item in x_selection"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :md="19" :sm="16" :xs="8">
                    <el-select
                      multiple
                      collapse-tags
                      filterable
                      v-model="conversion_list"
                      placeholder="Select targeting conversion flows"
                      @change="getOfferList_()"
                    >
                      <el-option
                        v-for="item in offer_setting.conversion_flow"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
                <el-button class="ml-2" @click="conversion_list = []">Clear</el-button>
              </div>
              <div class="tag-wrapper mb-4" v-show="conversion_list.length">
                <el-row class="tag-group">
                  <el-col :md="24">
                    <el-tag
                      class="mb-1 mr-1"
                      v-for="tag in offer_setting.conversion_flow"
                      v-show="conversion_list.includes(tag.id)"
                      @close="deleteTag(tag.id, 'conversion_list')"
                      :key="tag.id"
                      closable
                      :type="x_conversion ? 'danger' : ''"
                    >
                      {{ tag.name }}
                    </el-tag>
                  </el-col>
                </el-row>
              </div>
              <div class="form-group form-light target-group">
                <label class="label mr-8">
                  Carrier
                </label>
                <el-row class="form-control" :gutter="10">
                  <el-col :md="5" :sm="8" :xs="4">
                    <el-select
                      v-model="x_carrier"
                      @change="getOfferList_()"
                      :class="x_carrier ? 'deny' : 'allow'"
                    >
                      <el-option
                        v-for="item in x_selection"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :md="19" :sm="16" :xs="8">
                    <el-select
                      multiple
                      filterable
                      collapse-tags
                      v-model="carrier_list"
                      placeholder="Select targeting carriers"
                      @change="getOfferList_()"
                    >
                      <el-option
                        v-for="item in allCarriers"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
                <el-button class="ml-2" @click="carrier_list = []">Clear</el-button>
              </div>
              <div class="tag-wrapper mb-4" v-show="carrier_list.length">
                <el-row class="tag-group">
                  <el-col :md="24">
                    <el-tag
                      class="mb-1 mr-1"
                      v-for="tag in allCarriers"
                      v-show="carrier_list.includes(tag.id)"
                      @close="deleteTag(tag.id, 'carrier_list')"
                      :key="tag.id"
                      closable
                      :type="x_carrier ? 'danger' : ''"
                    >
                      {{ tag.name }}
                    </el-tag>
                  </el-col>
                </el-row>
              </div>
            </div>
          </section>

          <!-- Offer Setting -->
          <section class="panel" id="offer-setting">
            <div class="divider"><h3>Offers Setting (Optional)</h3></div>
            <p>
              The offers below have been added in your smartlink. You can select the one you want to
              prioritize or block. For the unapproved offers, you need to apply for them first.
            </p>
            <div class="form-control mt-2">
              <el-input @input="searchOffer" v-model="search" placeholder="Search offer"></el-input>
            </div>
            <el-table
              class="mt-4"
              ref="offerList"
              empty-text="No Data"
              :fit="true"
              border
              :data="normal.list"
            >
              <el-table-column
                type="selection"
                width="55"
                :selectable="checkApproveStatus"
              ></el-table-column>
              <el-table-column label="Offer" show-overflow-tooltip min-width="360px">
                <template slot-scope="scope">
                  {{ '(' + scope.row.oid + ')' + scope.row.name }}
                </template>
              </el-table-column>
              <el-table-column
                prop="payout_price"
                label="Payout($)"
                min-width="240px"
              ></el-table-column>
              <el-table-column label="Application Status" show-overflow-tooltip min-width="250px">
                <template slot-scope="scope">
                  {{ getApproveStatus(scope.row.approve_status) }}
                </template>
              </el-table-column>
              <el-table-column label="Action" min-width="280px">
                <template slot-scope="scope">
                  <el-button
                    class="long-button"
                    type="success"
                    @click="applyOffer(scope.row)"
                    v-if="scope.row.approve_status != 1"
                  >
                    Apply
                  </el-button>
                  <el-button
                    v-if="scope.row.approve_status === 1"
                    class="long-button"
                    type="success"
                    @click="moveOffer('normal', 'prior', '', { list: [scope.row] })"
                  >
                    Select
                  </el-button>
                  <el-button
                    v-if="scope.row.approve_status === 1"
                    class="long-button"
                    @click="moveOffer('normal', 'blocked', '', { list: [scope.row] })"
                    type="danger"
                  >
                    Block
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-row type="flex" justify="space-between" class="mt-2">
              <el-col :xs="12" :sm="12" :md="12">
                <el-button
                  class="long-button"
                  type="success"
                  @click="moveOffer('normal', 'prior', '', { form: 'offerList' })"
                >
                  Select
                </el-button>
                <el-button
                  class="long-button"
                  type="danger"
                  @click="moveOffer('normal', 'blocked', '', { form: 'offerList' })"
                >
                  Block
                </el-button>
              </el-col>
              <el-col :xs="12" :sm="12" :md="12">
                <el-pagination
                  class="right"
                  @current-change="getOfferList_"
                  :page-size.sync="normal.pageInfo.per"
                  :current-page.sync="normal.pageInfo.cur"
                  layout="prev, pager, next"
                  :total="normal.pageInfo.tot"
                ></el-pagination>
              </el-col>
            </el-row>
          </section>

          <!-- Prior Setting -->
          <section class="panel" v-if="prior.list.length > 0">
            <div class="non-divider">
              <h3 class="inline-block mr-2">Prior Offers</h3>
              <p class="mb-2">
                Traffic will be distributed to the offers according to your setting.
              </p>
            </div>
            <el-radio-group v-model="active">
              <el-card
                class="pointer prior-option mr-3"
                :class="{ 'selected-card': active === 'scope' }"
              >
                <el-radio label="scope">Set the scope</el-radio>
                <el-tooltip
                  enterable
                  content="All traffic will be sent to your prior offers."
                  placement="top"
                >
                  <i class="icon-y-question"></i>
                </el-tooltip>
              </el-card>
              <el-card
                class="pointer prior-option mr-3"
                :class="{ 'selected-card': active === 'weight' }"
              >
                <el-radio label="weight">Set weight</el-radio>
                <!-- <weight-example></weight-example> -->
                <el-tooltip
                  enterable
                  content="Distribute the traffic based on the weight setting. If an offer has a weight of 80, it will receive 80% of the targeting traffic."
                  placement="top"
                >
                  <i class="icon-y-question"></i>
                </el-tooltip>
              </el-card>
            </el-radio-group>
            <div v-if="active === 'scope'">
              <el-form :rules="rules" :model="offer_ratio" ref="prior_form">
                <prior-offer
                  ref="priorOffer"
                  :prior="prior"
                  :moveOffer="moveOffer"
                  type="scope"
                ></prior-offer>
              </el-form>
            </div>
            <div class="mt-2" v-if="active === 'weight'">
              <p class="mr-2 mb-2 inline-block">
                The ratio of clicks to preferred offers (Between 1 and 100):
              </p>
              <el-tooltip
                enterable
                content="The algorithm will just send the ratio of traffic you set to the preferred offers."
                placement="top"
              >
                <i class="icon-y-question"></i>
              </el-tooltip>
              <div class="">
                <el-input-number
                  v-model="prior_ratio"
                  controls-position="right"
                  :min="1"
                  :max="100"
                ></el-input-number>
              </div>
              <el-form :rules="rules" :model="offer_ratio" ref="prior_form">
                <prior-offer
                  ref="priorOffer"
                  :prior="prior"
                  :moveOffer="moveOffer"
                  :rules="rules"
                  :offer_ratio="offer_ratio"
                  type="weight"
                ></prior-offer>
              </el-form>
            </div>

            <el-row type="flex" justify="space-between" class="mt-2">
              <el-col :xs="12" :sm="12" :md="12">
                <el-button
                  class="long-button"
                  type="warning"
                  @click="moveOffer('prior', 'normal', '', { form: 'priorOffer' })"
                >
                  Delete
                </el-button>
                <el-button
                  class="long-button"
                  type="danger"
                  @click="moveOffer('prior', 'blocked', '', { form: 'priorOffer' })"
                >
                  Block
                </el-button>
              </el-col>
              <el-col :xs="12" :sm="12" :md="12">
                <el-pagination
                  class="right"
                  @current-change="priorPagination"
                  :page-size.sync="prior.pageInfo.per"
                  :current-page.sync="prior.pageInfo.cur"
                  layout="prev, pager, next"
                  :total="prior.pageInfo.tot"
                ></el-pagination>
              </el-col>
            </el-row>
            <el-row v-if="error_tip" type="flex" justify="end" class="right mt-1">
              <el-col :xs="12" :sm="12" :md="12">
                <p class="error_tip">
                  value error in other page
                </p>
              </el-col>
            </el-row>
          </section>

          <!-- Blocked Offers -->
          <section class="panel" v-if="blocked.list.length > 0">
            <div class="divider"><h3>Blocked Offers</h3></div>
            <el-table
              class="mt-5"
              ref="blockedOffer"
              empty-text="No Data"
              :fit="true"
              border
              :data="blocked.show_list"
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column label="Offer" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ '(' + scope.row.oid + ')' + scope.row.name }}
                </template>
              </el-table-column>
              <el-table-column>
                <template slot="header">
                  Action
                  <el-tooltip
                    enterable
                    content="Delete the offer if you want to add into smartlink again."
                    placement="top"
                  >
                    <i class="icon-y-question"></i>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  <el-button
                    class="long-button"
                    type="warning"
                    @click="moveOffer('blocked', 'normal', '', { list: [scope.row] })"
                  >
                    Delete
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-row type="flex" justify="space-between" class="mt-2">
              <el-col :xs="12" :sm="12" :md="12">
                <el-button
                  class="long-button"
                  @click="moveOffer('blocked', 'normal', '', { form: 'blockedOffer' })"
                  type="warning"
                >
                  Delete
                </el-button>
              </el-col>
              <el-col :xs="12" :sm="12" :md="12">
                <el-pagination
                  class="right"
                  @current-change="blockedPagination"
                  :page-size.sync="blocked.pageInfo.per"
                  :current-page.sync="blocked.pageInfo.cur"
                  layout="prev, pager, next"
                  :total="blocked.pageInfo.tot"
                ></el-pagination>
              </el-col>
            </el-row>
          </section>
        </div>
      </transition>
    </div>

    <div class="mt-8 center bottom-panel" v-if="!default_sml.includes(this.$route.params.sml_id)">
      <el-button @click="cancel" class="long-button">
        Cancel
      </el-button>
      <el-button type="primary" @click="create" class="long-button">
        Save Changes
      </el-button>
    </div>

    <div class="mt-8 center bottom-panel" v-else>
      <el-button @click="cancel" class="long-button">
        Back
      </el-button>
    </div>

    <el-dialog title="Preview" :visible.sync="dialogVisible" width="30%">
      <el-image style="width: 100%" :src="preview_url" fit="contain"></el-image>
    </el-dialog>
    <apply-offer
      v-if="show"
      :show.sync="show"
      :detailApply="detailApply"
      @cancel="show = false"
      @apply="applyCb"
    ></apply-offer>
  </el-card>
</template>

<script>
import { mapState } from 'vuex'
import priorOffer from '@/page/smartlink/priorOffer'
import applyOffer from '@/page/offers/applyOffer.vue'

export default {
  data() {
    return {
      ifAdvanced: false,
      active: 'scope',
      drawer: false,
      dialogVisible: false,
      action: 'create',
      sml_id: this.$route.params.sml_id,
      loading: false,
      filled_oid: 0,
      preview_url: '',
      detailApply: {},
      getofferlist_timer: 0,
      save_to_leave: false,
      ad_type: [
        {
          id: 1,
          label: 'CPI',
        },
        // {
        //   id: 2,
        //   label: 'CPA',
        // },
        {
          id: 4,
          label: 'CPL',
        },
      ],
      x_selection: [
        {
          id: 0,
          label: 'Allow',
        },
        {
          id: 1,
          label: 'Forbid',
        },
      ],
      allCarriers: [],
      creative_list: [],
      sml_link: {
        name: '',
        sml_type: 1,
        payout_price: 0,
        ad_type: 1,
        restriction_type: 1,
        allow_upstream_sml: false,
        prelander: 0,
        os: 0,
        access_type: 0,
        publish_type: 3,
        ader_sml: 1,
        strict: false,
        payout_ratio: 60,
        margin: 50,
        payout_fixed: false,
        package: 'com.cpisml.youmi',
        preview_url: '',
        icon_url:
          'http://static-abs.ymcdn.net/public/ad/preview/7634136300f3b0d7a4867b57b18fb33c.png',
      },
      sml_link_backup: {},
      rules: {
        name: [{ required: true, message: 'Can\'t be empty!', trigger: 'change' }],
        ratio: [
          {
            validator: this.validateRatio,
            trigger: 'blur',
          },
          { required: true, message: 'Can\'t be empty!', trigger: 'change' },
        ],
      },
      search: '',
      x_countrys: 0,
      country_list: [],
      x_category: 0,
      category_list: [],
      x_conversion: 0,
      conversion_list: [],
      x_carrier: 0,
      carrier_list: [],

      offer_ratio: {},
      // offer: {
      prior_ratio: 80,
      timer: 0,
      recommend: {
        list: [],
        filter_list: [],
        pageInfo: {
          cur: 0,
          per: 10,
          tot: 0,
        },
      },
      normal: {
        list: [],
        pageInfo: {
          cur: 1,
          per: 10,
          tot: 0,
        },
      },
      prior: {
        list: [],
        filter_list: [],
        show_list: [],
        pageInfo: {
          cur: 1,
          per: 10,
          tot: 0,
        },
      },
      blocked: {
        list: [],
        filter_list: [],
        show_list: [],
        pageInfo: {
          cur: 1,
          per: 10,
          tot: 0,
        },
      },
      error_tip: false,
      error_page: '',
      countrys: [],
      select_creative: {},

      creative_country: [],
      creative_category: [],
      show: false,
      size: {},
      creativePageInfo: {
        cur: 1,
        per: 12,
        tot: 0,
      },
      ad_format: 0,
      defaultImg: 'this.src="' + require('../../assets/img/offer-icon.png') + '"',
    }
  },
  computed: {
    ...mapState(['settings', 'channel_list', 'aid', 'offer_setting', 'default_sml']),
  },
  created() {
    this.customer_type = this.settings.user ? this.settings.user.customer_type : -1
    // 从菜单点进来sml_id参数不为0，待优化
    if (this.sml_id === ':sml_id') {
      this.sml_id = '0'
    }

    this.action = this.sml_id === '0' ? 'create' : 'edit'
    this.loading = true
    // 获取运营商列表
    this.$http
      .get('/api/common/get-carriers-r/', {})
      .then(data => {
        this.carrier = data
        // 将所有carriers拼接并且去重
        for (let i in this.carrier) {
          this.allCarriers = this.allCarriers.concat(this.carrier[i])
        }
        let unique = {}
        this.allCarriers.map(function(val) {
          unique[JSON.stringify(val)] = val
        })
        this.allCarriers = Object.keys(unique).map(function(val) {
          return JSON.parse(val)
        })
      })
      .catch(err => {
        this.notifyOpen('Error', this.executeError(err), 'error')
      })
    this.$store.dispatch('getOfferSetting')
    this.$store.dispatch('getChannelList').then(() => {
      if (this.action === 'edit') {
        this.getSmartLink().then(() => {
          let sml_link = this.sml_link
          this.getOfferList_(0, undefined, { x_oids: sml_link.offers.concat(sml_link.x_offers) })
          this.getCreativeList().then(() => {
            if (this.sml_link.p_material.id) {
              for (let i = 0; i < this.creative_list.length; i++) {
                let item = this.creative_list[i]
                if (Number(this.sml_link.p_material.id) === item.id) {
                  item.checked = true
                  this.select_creative = item
                  break
                }
              }
              this.ad_format = this.sml_link.p_material.p_ad_type
            }
            let [sml, send_tag] = this.generateSml(JSON.parse(JSON.stringify(this.sml_link)))
            this.sml_link_backup = { ...sml, ...send_tag }
          })
          this.hasAdvancedSetting()
        })
      } else {
        this.getOfferList_()
        let [sml, send_tag] = this.generateSml(JSON.parse(JSON.stringify(this.sml_link)))
        this.sml_link_backup = { ...sml, ...send_tag }
      }

      if (this.countrys.length === 0) {
        this.countrys = []

        this.$http
          .get('/api/common/get-countries-r/', {})
          .then(data => {
            for (var i = 0; i < data.list.length; i++) {
              var temp = data.list[i]
              temp.name_code = temp.name + '(' + temp.code + ')'
              this.countrys.push(temp)
            }
          })
          .catch(err => {
            this.notifyOpen('Error', this.executeError(err), 'error')
          })
      }
    })
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (to.params.sml_id === ':sml_id') {
        vm.$router.push({ path: '/smartlink/create/0/' })
      }
    })
  },
  beforeRouteLeave(to, from, next) {
    let [sml, send_tag] = this.generateSml(JSON.parse(JSON.stringify(this.sml_link)))
    let now_sml = { ...sml, ...send_tag }
    delete now_sml['filled_oid']
    delete this.sml_link_backup['filled_oid']
    let change = JSON.stringify(now_sml) !== JSON.stringify(this.sml_link_backup)
    if (!this.save_to_leave && change) {
      this.confirmOpen(
        'The changes will not be saved. Are you sure to leave?',
        () => {
          next()
        },
        () => {}
      )
    } else {
      next()
    }
  },
  methods: {
    hasAdvancedSetting() {
      if (
        this.country_list.length ||
        this.category_list.length ||
        this.conversion_list.length ||
        this.carrier_list.length ||
        this.sml_link.offers.length ||
        this.sml_link.x_offers.length
      ) {
        this.ifAdvanced = true
      }
    },
    changeRestrictionType(item) {
      this.sml_link.restriction_type = item.id
    },
    changeAdType() {
      if (this.sml_link.ad_type === 1) {
        this.sml_link.restriction_type = 1
      }
      if (this.sml_link.ad_type === 4) {
        this.sml_link.prelander = 0
      }
      this.getOfferList_()
    },
    changePrelander() {
      this.getOfferList_()
    },
    checkApproveStatus(row) {
      return row.approve_status === 1
    },
    applyOffer(offer) {
      if (this.settings.user.status === 0) {
        this.updateInfo(this.$route.path)
        return
      }

      this.detailApply = {
        offer: offer,
        channel_list: this.channel_list,
        aid: this.aid,
        link_type: 1,
      }
      this.show = true
    },
    applyCb() {
      this.detailApply.offer.approve_status = 0
      this.detailApply.offer.status = 0
      this.show = false
    },
    validateRatio(rule, value, callback) {
      let prior_list = this.offer_ratio
      this.error_tip = false
      for (let i in prior_list) {
        let value = Number(prior_list[i])
        if (isNaN(Number(value)) || (Number(value) > 100 || Number(value) < 1) || value % 1 !== 0) {
          let in_show_list = false
          for (let k = 0; k < this.prior.show_list.length; k++) {
            if (Number(this.prior.show_list[k].oid) === Number(i)) {
              in_show_list = true
            }
          }
          if (!in_show_list) {
            this.error_tip = true
          }
        }
      }
      if (isNaN(Number(value))) {
        callback(new Error('please enter a valid number!'))
      } else if (Number(value) > 100 || Number(value) < 1) {
        callback(new Error('1 <= weight <= 100'))
      } else if (value % 1 !== 0) {
        callback(new Error('please enter an Integer'))
      } else if (this.error_tip) {
        callback(new Error(' '))
      } else {
        this.error_tip = false
        callback()
      }
    },
    getTagSetting() {
      return {
        carriers: this.x_carrier ? [] : this.carrier_list,
        x_carriers: this.x_carrier ? this.carrier_list : [],
        conversion_flow: this.x_conversion ? [] : this.conversion_list,
        x_conversion_flow: this.x_conversion ? this.conversion_list : [],
        categories: this.x_category ? [] : this.category_list,
        x_categories: this.x_category ? this.category_list : [],
        countries: this.x_countrys ? [] : this.country_list,
        x_countries: this.x_countrys ? this.country_list : [],
      }
    },
    setTagResultList(list, tag_key, status, key) {
      if (!list || !list.length) {
        return
      }
      this[key] = status
      this[tag_key] = list
    },
    getAdsList(page_current, table, id_list, search) {
      // let offer = this.offer;
      let form = this[table || 'normal']
      let params = {
        search: search,
        p: page_current || 1,
        contain_api: 1,
        n: 100000,
        approve_status: -1,
        is_accurate: 1,
        oids: id_list ? id_list.oids : undefined,
      }
      this.$http.get('/api/offers/list/', { params: params }).then(res => {
        form.list = res.data
        form.filter_list = res.data

        this.customPagination(1, form)
      })
    },
    getSmartLink() {
      return this.$http.get(`/api/smartlink/${this.sml_id}/`).then(res => {
        this.loading = false
        this.payout_type = res.payout_price > 0 ? 2 : 1
        this.sml_link = res
        this.sml_link.strict = Boolean(this.sml_link.strict)
        if (this.sml_link.aff_settings[this.aid]) {
          this.sml_link.offers = this.sml_link.aff_settings[this.aid].offers
          this.sml_link.x_offers = this.sml_link.aff_settings[this.aid].x_offers
          this.offer_ratio = this.sml_link.aff_settings[this.aid].offer_ratio
          if (this.sml_link.aff_settings[this.aid].prior_ratio >= 1) {
            this.active = 'weight'
            this.prior_ratio = this.sml_link.aff_settings[this.aid].prior_ratio
          }
        }

        let setTagResultList = this.setTagResultList

        if (this.sml_link.offers && this.sml_link.offers.length) {
          this.getAdsList(1, 'prior', { oids: this.sml_link.offers })
        }
        if (this.sml_link.x_offers && this.sml_link.x_offers.length) {
          this.getAdsList(1, 'blocked', { oids: this.sml_link.x_offers })
        }
        setTagResultList(res.categories, 'category_list', 0, 'x_category')
        setTagResultList(res.x_categories, 'category_list', 1, 'x_category')
        setTagResultList(res.conversion_flow, 'conversion_list', 0, 'x_conversion')
        setTagResultList(res.x_conversion_flow, 'conversion_list', 1, 'x_conversion')
        setTagResultList(res.countries, 'country_list', 0, 'x_countrys')
        setTagResultList(res.carriers, 'carrier_list', 0, 'x_carriers')
        return res
      })
    },
    searchOffer(search) {
      this.searchRemoteOffer(this.search)
    },
    deleteTag(tag, list) {
      this[list].splice(this[list].indexOf(tag), 1)
    },
    searchRemoteOffer(search) {
      let offer = this
      clearTimeout(offer.timer)
      offer.timer = setTimeout(() => {
        this.getOfferList_(1, undefined, undefined, search)
      }, 500)
    },
    getOfferList_(page_current, table, id_list, search) {
      clearTimeout(this.getofferlist_timer)
      let callback = () => {
        let sml_link = this.sml_link
        let offer = this
        let x_oids = id_list
          ? id_list.x_oids
          : this.getIdArray(offer.blocked.list, 'oid').concat(
              this.getIdArray(offer.prior.list, 'oid')
            ) // 后端用于过滤掉已选中的prior offer和blocked offer
        let params = {
          search: search || this.search,
          p: page_current || 1,
          ad_type: sml_link.ad_type,
          os: sml_link.os,
          n: 10,
          x_oids: x_oids,
          do_filter_none: 1,
          is_prelander: sml_link.prelander,
          restriction_type: sml_link.restriction_type,
          access_type: sml_link.access_type === 0 ? [1, 2] : sml_link.access_type,
          allow_upstream_sml: Number(sml_link.allow_upstream_sml),
          payout_type: [1, 2, 3],
          ...this.getTagSetting(),
        }

        this.$http
          .post('/api/smartlink/get-offer/', params)
          .then(res => {
            this.loading = false
            this['normal'].list = res.data
            this.tot = res.tot
            if (this['normal'].list.length) {
              this.filled_oid = this['normal'].list[0].oid
            } else if (!search) {
              this.filled_oid = 0
            }
            this.changePageItem(this.normal.pageInfo, res)
          })
          .catch(error => {
            this.loading = false
            this.notifyOpen('Error', this.executeError(error), 'error')
          })
      }
      this.getofferlist_timer = setTimeout(() => {
        callback()
      }, 500)
    },
    priorPagination(page_current) {
      this.customPagination(page_current, this.prior)
    },
    blockedPagination(page_current) {
      this.customPagination(page_current, this.blocked)
    },
    customPagination(page_current, table) {
      let filter_list = table.filter_list
      let pageInfo = table.pageInfo
      let per_page = pageInfo.per
      let start_index = (page_current - 1) * per_page

      pageInfo.cur = page_current
      pageInfo.tot = filter_list.length
      filter_list.forEach(item => {
        item.ratio = 0
      })
      table.show_list = [...filter_list.slice(start_index, start_index + per_page)]
    },
    moveOffer(from, to, parent, params) {
      parent = this
      let list =
        params.list ||
        this.$refs[params.form].selection ||
        this.$refs[params.form].$refs[params.form].selection
      if (!list.length) {
        return
      }
      let parent_to = parent[to]
      let parent_from = parent[from]
      if (from === 'recommend') {
        let offer = list[0]
        for (let i = 0; i < parent_to.list.length; i++) {
          let item = parent_to.list[i]
          if (Number(item.oid) === Number(offer.oid)) {
            return
          }
        }
      }

      parent_from.list = this.subArg(parent_from.list, list, 'oid')
      if (to === 'recommend') {
        let diffence = []
        for (let k = 0; k < list.length; k++) {
          let diff_item = list[k]
          for (let i = 0; i < parent_to.list.length; i++) {
            let item = parent_to.list[i]
            if (diff_item.oid === Number(item.oid)) {
              diffence.push(diff_item)
            }
          }
        }

        let cut = list.concat(diffence).filter(v => !list.includes(v) || !diffence.includes(v))
        parent_to.list = cut.concat(parent_to.list)
      } else {
        parent_to.list = list.concat(parent_to.list)
      }

      if (to !== 'normal' && to !== 'recommend') {
        parent_to.filter_list = list.concat(parent_to.filter_list)
        this.customPagination(parent_to.pageInfo.cur, parent_to)
      } else {
        parent_to.pageInfo.tot += list.length
        this.filled_oid = list[0] ? list[0].oid : 0
      }
      if (from !== 'normal' && from !== 'recommend') {
        if (from === 'prior') {
          list.forEach(item => {
            // this.$delete(this.offer_ratio, item.oid)
            delete this.offer_ratio[item.oid]
          })
        }
        parent_from.filter_list = this.subArg(parent_from.filter_list, list, 'oid')
        if (list.length === parent_from.show_list.length && parent_from.pageInfo.cur > 1) {
          parent_from.pageInfo.cur--
        }
        this.customPagination(parent_from.pageInfo.cur, parent_from)
      } else {
        parent_from.pageInfo.tot -= list.length

        if (parent_from.list.length <= 0) {
          this.filled_oid = 0
          this.getOfferList_()
        }
      }

      if (params.form) {
        if (this.$refs[params.form].clearSelection) {
          this.$refs[params.form].clearSelection()
        } else {
          this.$refs[params.form].$refs[params.form].clearSelection()
        }
      }
      if (to === 'prior') {
        list.forEach(item => {
          this.$set(this.offer_ratio, item.oid, 10)
        })
      }
    },
    // 获取选中的offer id列表
    getOfferSelect(list) {
      if (!list.length) {
        return
      }
      let result = []
      for (let i = 0, il = list.length; i < il; i++) {
        let item = list[i]
        result.push(item.oid)
      }
      return result
    },
    getApproveStatus(status) {
      return status === 0
        ? 'Pending'
        : status === 2
        ? 'Unapproved'
        : status === 1
        ? 'Approved'
        : 'Rejected'
    },
    getCreativeList(index) {
      this.loading = true
      let { width, height } = this.size
      return this.$http
        .get('/api/smartlink/creative', {
          params: {
            offer_type: this.sml_link.ad_type ? this.sml_link.ad_type : 2, // 0的按CPA处理
            ad_type: this.ad_format || undefined,
            category: this.creative_category,
            country: this.creative_country,
            width: width,
            height: height,
            p: index || 1,
            n: this.creativePageInfo.per,
          },
        })
        .then(data => {
          this.loading = false
          let list = data.data
          list.forEach(item => {
            item.checked = false
            if (
              Object.keys(this.select_creative).length > 0 &&
              this.select_creative.id === item.id
            ) {
              item.checked = true
            }
          })
          this.creative_list = list
          this.changePageItem(this.creativePageInfo, data)
        })
        .catch(error => {
          this.loading = false
          this.notifyOpen('Error', error.m, 'error')
        })
    },
    generateSml(sml_link = this.sml_link) {
      let offer = this
      sml_link.allow_upstream_sml = Number(sml_link.allow_upstream_sml)
      sml_link.payout_fixed = Number(sml_link.payout_fixed)
      sml_link.payout_price = Number(sml_link.payout_price)
      sml_link.strict = Number(sml_link.strict)
      sml_link.uid = this.aid
      if (sml_link.ad_type !== 1) {
        sml_link.package = 'com.cpisml.youmi'
        sml_link.preview_url = ''
        sml_link.icon_url =
          'http://static-abs.ymcdn.net/public/ad/preview/7634136300f3b0d7a4867b57b18fb33c.png'
      }
      let { x_countries, x_carriers, traffic_allow, x_traffic_allow, ...send_tag } = {
        ...this.getTagSetting(),
      }
      let affsetting = {}
      affsetting[this.aid] = {
        aid: sml_link.uid,
        ad_type: sml_link.ad_type,
        offers: this.getOfferSelect(offer.prior.list),
        x_offers: this.getOfferSelect(offer.blocked.list),
        offer_ratio: this.offer_ratio,
        prior_ratio: this.active === 'scope' ? -1 : this.prior_ratio,
      }
      let p_material = {}
      p_material.p_ad_type = this.ad_format
      p_material.id = this.select_creative.id
      sml_link.aff_settings = JSON.stringify(affsetting)
      sml_link.p_material = JSON.stringify(p_material)
      sml_link.filled_oid = this.filled_oid || 200580 // 若是filled_oid为0，中间层会报错，默认可用200580填充
      return [sml_link, send_tag]
    },
    create() {
      let url =
        this.action === 'eidt' ? `/api/smartlink/${this.sml_id}/update/` : '/api/smartlink/create/'
      let valid1 = true
      let valid2 = true
      this.$refs['createSmartlink'].validate(valid => {
        valid1 = valid
      })

      if (this.active === 'weight') {
        let form = 'prior_form'
        if (this.$refs[form]) {
          this.$refs[form].validate(valid => {
            valid2 = valid
          })
        }
      }

      if (valid1 && valid2) {
        this.loading = true
        let [sml_link, send_tag] = this.generateSml()
        this.$http
          .post(url, {
            ...sml_link,
            ...send_tag,
          })
          .then(res => {
            this.loading = false
            this.save_to_leave = true
            this.$router.push({ path: '/smartlink', query: { active: 'my' } })
          })
          .catch(error => {
            this.loading = false
            this.notifyOpen('Error', this.executeError(error), 'error')
          })
      }
    },
    cancel() {
      this.$router.push({ path: '/smartlink' })
    },
  },
  components: {
    priorOffer,
    applyOffer,
  },
}
</script>

<style lang="scss">
.el-select-dropdown {
  .el-select-dropdown__item.cpl_bonus::after {
    content: 'bonus';
    display: inline-block;
    text-align: center;
    width: 44px;
    height: 16px;
    line-height: 16px;
    border: 1px solid rgba(255, 153, 51, 1);
    border-radius: 4px 4px 4px 0px;
    background: rgba(255, 153, 51, 0.1);
    font-size: 12px;
    font-weight: 600;
    color: #fba324;
    position: relative;
    left: 13px;
    top: -2px;
  }
}
.create-smart-link {
  .el-drawer__header {
    & > :first-child {
      font-size: 20px;
      font-weight: 400;
      color: rgba(0, 128, 204, 1);
      line-height: 28px;
    }
  }
  .el-drawer__body {
    h3 {
      display: inline-block;
      line-height: 24px;
    }
    p {
      font-size: 12px;
      line-height: 28px;
    }
    .prior-list {
      padding-bottom: 60px;
    }
    .recommend-list .el-table__body-wrapper {
      height: 240px;
      overflow-y: scroll;
    }
    .el-input-number {
      width: 400px;
    }
  }

  .drawer_bottom {
    position: absolute;
    bottom: 0;
    width: 100%;
    left: 0;
    padding: 12px;
    border-top: 1px solid #eef0f6;
    background: #fff;
    z-index: 999;
  }
  &.el-card {
    overflow: visible;
  }
  .el-card__body {
    overflow: visible;
    width: 100%;
    padding: 0;
  }
  .el-input-number {
    width: 540px;
    input {
      text-align: left;
    }
  }
  .prior-option {
    display: flex;
    align-items: center;
    width: 166px;
    height: 40px;
    box-shadow: none !important;
    .el-card__body {
      text-align: center;
    }
    .el-radio {
      margin-right: 10px;
    }
    // border: 1px solid #0080cc;
  }

  .bottom-panel {
    position: sticky;
    bottom: -26px;
    z-index: 999;
    background: #fff;
    padding: 12px;
    border-top: 1px solid #eef0f6;
  }
  .wrapper {
    padding: 0 28px 0 28px;
    min-height: 700px;
  }
  p {
    color: #6b6d71;
    font-size: 14px;
  }
  .flex-center {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: wrap;
  }
  .panel {
    margin: 20px auto;
    padding-bottom: 40px;
  }
  .el-tag {
    line-height: 24px;
    height: 24px;
  }
  .form-group {
    height: 32px;
    margin-bottom: 10px;
    margin-left: -135px;
  }

  .target-group {
    margin-top: 15px;
    flex-wrap: nowrap;
    height: auto;
  }
  .tag-group {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 12px;
    margin-left: 75px;
    overflow-y: auto;
    width: 590px;
    height: 100%;
  }
  .tag-wrapper {
    margin-top: 15px;
    margin-bottom: 40px;
    height: 120px;
  }
  .radio-group {
    align-items: center;
    display: inline-flex;
    .el-form-item {
      margin-bottom: 0;
    }
  }

  .el-select {
    height: 32px;
  }
  .label {
    width: 120px;
  }
  .label.mr-8 {
    margin-right: 40px;
  }
  .s-label {
    color: #9b9ea3;
    font-size: 14px;
  }
  .form-control {
    width: 476px;
    .el-form-item {
      width: 100%;
    }
  }
  .non-divider {
    h3 {
      color: #6b6d71;
      font-size: 16px;
      line-height: 36px;
    }
  }
  .divider {
    position: relative;
    h3 {
      color: #6b6d71;
      font-size: 16px;
      line-height: 36px;
    }
    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 1px;
      background-color: #e4e7ed;
      z-index: 1;
    }
  }

  .allow {
    .el-input__inner {
      border: 1px solid #0080cc;
      color: #0080cc;
    }
    .el-input {
      &.is-focus .el-input__inner {
        border-color: #0080cc;
      }
      .el-select__caret {
        color: #0080cc;
      }
    }
  }
  .deny {
    .el-input__inner {
      border: 1px solid #f56c6c;
      color: #f56c6c;
    }
    .el-input {
      &.is-focus .el-input__inner {
        border-color: #f56c6c;
      }
      .el-select__caret {
        color: #f56c6c;
      }
    }
  }
  .target-tag {
    background: #eaf2f6;
    border-color: #eaf2f6;
  }
  .el-tag--danger {
    background: #f6eaea;
    border-color: #f6eaea;
  }
  .ratio {
    margin-bottom: 0;
    padding: 16px 0;
  }

  .error_tip {
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
  }

  .creative-box {
    padding: 32px 22px;
    height: 546px;
    overflow-y: scroll;
    background: #f6f8fb;
    border-radius: 4px;
    border: 1px solid #ebeef5;
    .box {
      margin: 0 -12px;
    }
    .creative-card-box {
      margin: 0 12px 32px 12px;
      display: inline-block;
    }
  }

  .creative-card-box {
    max-width: 224px !important;
    width: 224px;
    height: 204px;
    .el-card {
      box-shadow: none !important;
      &:hover {
        box-shadow: 0px 10px 20px 0px rgba(36, 117, 164, 0.16) !important;
      }
    }
    .el-card__body {
      padding: 0;
    }
    .icon-y-ym_view {
      font-size: 24px;
    }
  }
  .creative {
    position: relative;
    height: 126px;
    overflow: hidden;
    width: 100%;
    text-align: center;
  }
  .creative-info {
    padding: 12px 16px 12px 16px;
  }

  .ad-format-box {
    display: flex;
    align-items: center;
    text-align: center;
    width: 226px;
    height: 138px;
    .el-radio {
      margin-right: 0;
    }
  }
  i.icon-y-ym_star_full {
    color: #84d245;
  }
  .ad-format {
    width: 105px;
  }
  i.icon-y-ym_star {
    color: #c7cbd2;
  }
  .el-tag.el-tag--info {
    background-color: #f6f8fb;
    border-color: #eef0f6;
  }
  .layer {
    position: absolute;
    width: 100%;
    height: 100%;
    background: #37383a;
    opacity: 0.6;
    z-index: 999;
  }

  .icon-y-ym_view {
    color: #fff;
    z-index: 1100;
    position: absolute;
    top: 60px;
    left: 45%;
  }

  .el-input--suffix .el-input__inner {
    height: 32px !important;
  }

  .el-icon-more {
    &:hover {
      color: #0080cc;
    }
  }
  .icon {
    width: 56px;
    height: 56px;
    cursor: pointer;
  }
  .card-group {
    height: 138px !important;
    .ad-format-box {
      width: 226px;
      height: 138px;
    }
  }
  .el-button.grey {
    border: 1px solid #e1e4eb;
    color: #6b6d71;
    i {
      color: #d0d3d9;
    }
    &:hover {
      background: #fff;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.ym-container.el-container .ym-main .create-smart-link .el-card.is-always-shadow {
  box-shadow: 0px 10px 20px 0px rgba(36, 117, 164, 0.16);
}
</style>
